import "./link-banner-block.scss";